import React from "react";
import { cn } from "@/lib/utils";

export function Crosshair({ className }) {
  return <div className={cn("crosshair-divider my-6", className)} data-testid="crosshair-divider" />;
}

export function MilDot() {
  return <span className="inline-block w-[3px] h-[3px] rounded-full bg-olive align-middle mx-2" />;
}
